// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jrn__sub {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  color: var(--portal-muted);
  margin: -0.75rem 0 0;
}
.jrn__timeline {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0.25rem 0 0.5rem;
}

/* Each step row */
.jrn__tl-item {
  display: flex;
  align-items: flex-start;
  gap: 1.25rem;
}

/* Left track — dot + vertical connector line */
.jrn__tl-track {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  padding-top: 0.1rem;
}

/* The dot itself */
.jrn__tl-dot {
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 2px solid transparent;
  transition: all 0.2s;
}
.jrn__tl-dot--done {
  background: #1e2a1e;
  border-color: #1e2a1e;
}
.jrn__tl-dot--active {
  background: transparent;
  border-color: #b85c38;
  box-shadow: 0 0 0 4px rgba(184, 92, 56, 0.15);
}
.jrn__tl-dot--pending {
  background: transparent;
  border-color: var(--portal-border, #e8e3da);
}

/* Check icon inside done dot */
.jrn__tl-check {
  font-size: 1.05rem;
  color: #fff;
  stroke-width: 2.5;
}

/* Step number inside pending/active dots */
.jrn__tl-num {
  font-size: 0.75rem;
  font-weight: 800;
  color: var(--portal-muted, #6b6258);
}
.jrn__tl-dot--active .jrn__tl-num {
  color: #b85c38;
}

/* Connector line between dots */
.jrn__tl-line {
  width: 2px;
  flex: 1 1;
  min-height: 2rem;
  background: var(--portal-border, #e8e3da);
  margin: 0.35rem 0;
}
.jrn__tl-line--done {
  background: #1e2a1e;
}

/* Right side — text label */
.jrn__tl-label {
  padding: 0.2rem 0 1.75rem;
  flex: 1 1;
  min-width: 0;
}
/* Last item — no bottom padding (no line below it) */
.jrn__tl-item:last-child .jrn__tl-label {
  padding-bottom: 0;
}
.jrn__tl-label--active {
  /* subtle left accent for active step */
}

.jrn__tl-name {
  font-family: var(--font-body);
  font-size: 0.92rem;
  font-weight: 700;
  color: var(--portal-text, #1b1b1b);
  margin: 0 0 0.25rem;
  letter-spacing: 0;
}
.jrn__tl-name--active { color: #b85c38; }
.jrn__tl-name--done   { color: #1e2a1e; }

.jrn__tl-sub {
  font-family: var(--font-body);
  font-size: 0.82rem;
  color: var(--portal-muted, #6b6258);
  margin: 0;
  line-height: 1.5;
}

.jrn__tl-date {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.74rem;
  color: var(--portal-muted, #6b6258);
  margin: 0.35rem 0 0;
  background: rgba(30, 42, 30, 0.06);
  padding: 0.2rem 0.6rem;
  border-radius: 99px;
}
.jrn__lower {
  display: grid;
  grid-template-columns: 1fr 1.6fr;
  gap: var(--sp-4);
  align-items: start;
}
.jrn__current {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--sp-3);
}
.jrn__current-icon {
  margin-block: var(--sp-3);
}
.jrn__current-title {
  font-family: var(--font-body);
  font-size: 1.02rem;
  font-weight: 700;
  color: var(--portal-rust);
  margin: 0;
}
.jrn__current-desc {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  color: var(--portal-muted);
  margin: 0;
  line-height: 1.55;
}
.jrn__current-note {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: var(--portal-surface);
  border-radius: 6px;
  padding: 0.65rem 0.85rem;
  font-size: 0.734rem;
  color: var(--portal-muted);
}
.jrn__current-note svg {
  color: var(--portal-rust);
  flex-shrink: 0;
}
.jrn__next-list {
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
}
.jrn__next-item {
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
}
.jrn__next-body {
  flex: 1 1;
}
.jrn__next-title {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  font-weight: 700;
  color: var(--portal-text);
  margin: 0 0 0.2rem;
}
.jrn__next-desc {
  font-family: var(--font-body);
  font-size: 0.796rem;
  color: var(--portal-muted);
  margin: 0;
  line-height: 1.45;
}
.jrn__next-time {
  font-family: var(--font-body);
  font-size: 0.663rem;
  font-weight: 700;
  color: var(--portal-rust);
  white-space: nowrap;
  flex-shrink: 0;
}
.jrn__bottom {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--sp-5);
  align-items: center;
  overflow: hidden;
  position: relative;
}
.jrn__quote {
  font-family: var(--font-serif);
  font-style: italic;
  font-size: clamp(1rem, 1.5vw, 1.2rem);
  color: var(--portal-muted);
  margin: 0;
  line-height: 1.5;
}
.jrn__quote cite {
  display: block;
  font-size: 0.694rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--portal-rust);
  font-style: normal;
  margin-top: 0.5rem;
}
.jrn__support {
  display: flex;
  align-items: flex-start;
  gap: var(--sp-3);
}
.jrn__support svg {
  font-size: 1.224rem;
  color: var(--portal-rust);
  flex-shrink: 0;
  margin-top: 2px;
}
.jrn__support-title {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  font-weight: 700;
  color: var(--portal-text);
  margin: 0 0 0.2rem;
}
.jrn__support-sub {
  font-family: var(--font-body);
  font-size: 0.796rem;
  color: var(--portal-muted);
  margin: 0;
}
.jrn__bottom-mtn {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 180px;
  height: 100px;
  object-fit: cover;
  opacity: 0.18;
  pointer-events: none;
  filter: grayscale(1);
}
@media (max-width: 767.98px) {
  .jrn__lower {
    grid-template-columns: 1fr;
  }
  .jrn__bottom {
    grid-template-columns: 1fr;
  }
}

/* ── Ref chip ── */
.jrn__ref-chip {
  display: inline-flex; align-items: center; gap: 0.4rem;
  font-size: 0.78rem; color: var(--portal-muted,#6b6258);
  background: var(--portal-surface,#faf7f2);
  border: 1px solid var(--portal-border,#e8e3da);
  border-radius: 99px; padding: 0.3rem 0.85rem;
}

/* ═══════════════════════════════════════════════════════════
   Retreat offer / queue cards
═══════════════════════════════════════════════════════════ */

.jrn__offer-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 2.25rem 2rem;
  margin-bottom: 1.25rem;
}
.jrn__offer-card--pending {
  background: linear-gradient(135deg, #1e2a1e 0%, #2d3e2d 100%);
  border: 1px solid rgba(184,92,56,0.35);
}
.jrn__offer-card--confirmed {
  background: rgba(22,163,74,0.05);
  border: 1px solid rgba(22,163,74,0.25);
}

.jrn__offer-icon {
  width: 3.5rem; height: 3.5rem; border-radius: 50%;
  background: rgba(184,92,56,0.15);
  display: flex; align-items: center; justify-content: center;
  font-size: 1.5rem; color: #b85c38;
  margin-bottom: 0.85rem;
}
.jrn__offer-icon--confirmed { background: rgba(22,163,74,0.15); color: #16a34a; }

.jrn__offer-card--pending .jrn__offer-eyebrow {
  font-size: 0.7rem; font-weight: 700; letter-spacing: 0.16em; text-transform: uppercase;
  color: #b85c38; margin: 0 0 0.5rem;
}
.jrn__offer-card--confirmed .jrn__offer-eyebrow {
  font-size: 0.7rem; font-weight: 700; letter-spacing: 0.16em; text-transform: uppercase;
  color: #16a34a; margin: 0 0 0.5rem;
}

.jrn__offer-card--pending .jrn__offer-title { font-family: var(--font-serif); font-size: 1.5rem; font-weight: 700; color: #fff; margin: 0 0 0.65rem; }
.jrn__offer-card--confirmed .jrn__offer-title { font-family: var(--font-serif); font-size: 1.5rem; font-weight: 700; color: #1b1b1b; margin: 0 0 0.65rem; }

.jrn__offer-dates, .jrn__offer-location {
  display: flex; align-items: center; gap: 0.4rem; justify-content: center;
  font-size: 0.88rem; margin: 0 0 0.35rem;
}
.jrn__offer-card--pending .jrn__offer-dates,
.jrn__offer-card--pending .jrn__offer-location { color: rgba(255,255,255,0.75); }
.jrn__offer-card--confirmed .jrn__offer-dates,
.jrn__offer-card--confirmed .jrn__offer-location { color: var(--portal-muted, #6b6258); }

.jrn__offer-expiry {
  font-size: 0.85rem; color: rgba(255,255,255,0.65); margin: 0.85rem 0 1.25rem;
}
.jrn__offer-expiry strong { color: #fff; }

.jrn__offer-confirmed-note {
  font-size: 0.85rem; color: var(--portal-muted, #6b6258);
  margin: 0.85rem 0 0; max-width: 400px; line-height: 1.6;
}

.jrn__offer-actions { display: flex; gap: 0.65rem; flex-wrap: wrap; justify-content: center; }
.jrn__offer-accept, .jrn__offer-decline {
  display: inline-flex; align-items: center; gap: 0.4rem;
  padding: 0.7rem 1.35rem; border-radius: 8px;
  font-size: 0.86rem; font-weight: 700; cursor: pointer;
  transition: opacity 0.15s; border: none;
}
.jrn__offer-accept { background: #b85c38; color: #fff; }
.jrn__offer-accept:hover:not(:disabled) { opacity: 0.88; }
.jrn__offer-accept:disabled { opacity: 0.5; cursor: wait; }
.jrn__offer-decline { background: rgba(255,255,255,0.08); color: rgba(255,255,255,0.7); border: 1px solid rgba(255,255,255,0.2); }
.jrn__offer-decline:hover:not(:disabled) { background: rgba(255,255,255,0.14); }

/* ── Queue waiting card ── */
.jrn__queue-card {
  display: flex; align-items: center; gap: 1rem;
  padding: 1.25rem 1.5rem; margin-bottom: 1.25rem;
  background: rgba(217,119,6,0.05);
  border: 1px solid rgba(217,119,6,0.2);
}
.jrn__queue-icon { font-size: 1.75rem; color: #d97706; flex-shrink: 0; }
.jrn__queue-title { font-size: 0.92rem; font-weight: 700; color: #1b1b1b; margin: 0 0 0.25rem; }
.jrn__queue-sub { font-size: 0.82rem; color: var(--portal-muted, #6b6258); margin: 0; line-height: 1.55; }

@media (max-width: 640px) {
  .jrn__offer-actions { flex-direction: column-reverse; width: 100%; }
  .jrn__offer-accept, .jrn__offer-decline { justify-content: center; width: 100%; }
  .jrn__queue-card { flex-direction: column; text-align: center; }
}

/* ── Open selection block/room picker ── */
.jrn__block-picker {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  width: 100%;
  margin: 1.25rem 0;
  text-align: left;
}
.jrn__block-option {
  background: rgba(255,255,255,0.06);
  border: 1.5px solid rgba(255,255,255,0.15);
  border-radius: 10px;
  padding: 0.9rem 1.1rem;
  cursor: pointer;
  transition: all 0.15s;
}
.jrn__block-option:hover { border-color: rgba(184,92,56,0.5); background: rgba(255,255,255,0.09); }
.jrn__block-option--selected { border-color: #b85c38; background: rgba(184,92,56,0.12); }

.jrn__block-option-name { font-size: 0.95rem; font-weight: 700; color: #fff; margin: 0 0 0.3rem; }
.jrn__block-option-dates {
  display: flex; align-items: center; gap: 0.35rem;
  font-size: 0.8rem; color: rgba(255,255,255,0.65); margin: 0 0 0.2rem;
}

.jrn__roomtype-picker {
  display: flex; flex-direction: column; gap: 0.5rem;
  margin-top: 0.75rem; padding-top: 0.75rem;
  border-top: 1px solid rgba(255,255,255,0.12);
}
.jrn__roomtype-opt {
  display: flex; align-items: flex-start; gap: 0.55rem;
  padding: 0.6rem 0.75rem;
  border: 1px solid rgba(255,255,255,0.15);
  border-radius: 7px;
  font-size: 0.82rem; color: rgba(255,255,255,0.85);
  cursor: pointer; transition: all 0.13s;
}
.jrn__roomtype-opt:hover { border-color: rgba(184,92,56,0.5); }
.jrn__roomtype-opt--selected { border-color: #b85c38; background: rgba(184,92,56,0.15); font-weight: 600; color: #fff; }
.jrn__roomtype-opt input { accent-color: #b85c38; width: 0.95rem; height: 0.95rem; flex-shrink: 0; margin-top: 0.2rem; }
.jrn__roomtype-opt-body { display: flex; flex-direction: column; gap: 0.5rem; flex: 1 1; min-width: 0; }

.jrn__roomtype-photos {
  display: flex;
  gap: 0.4rem;
  flex-wrap: wrap;
}
.jrn__roomtype-photos img {
  width: 3.75rem;
  height: 3.75rem;
  object-fit: cover;
  border-radius: 6px;
  flex-shrink: 0;
  background: rgba(255,255,255,0.08);
}

/* ── Targeted offer's room photos ── */
.jrn__offer-room { display: flex; flex-direction: column; gap: 0.5rem; align-items: center; }
.jrn__offer-room-photos {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  justify-content: center;
}
.jrn__offer-room-photos img {
  width: 4.5rem;
  height: 4.5rem;
  object-fit: cover;
  border-radius: 8px;
  background: rgba(255,255,255,0.08);
}

/* Link from the confirmed card to the booking page */
.jrn__offer-link {
  display: inline-flex; align-items: center; gap: 0.4rem; margin-top: 0.9rem;
  color: #fff; font-weight: 700; font-size: 0.85rem; text-decoration: underline; text-underline-offset: 3px;
}
.jrn__offer-link:hover { color: #f0a47f; }
a.jrn__offer-accept { text-decoration: none; }
`, "",{"version":3,"sources":["webpack://./src/portal/JourneyPage.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,0BAA0B;EAC1B,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;AACrC;AACA;EACE,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,UAAU;EACV,SAAO;EACP,gBAAgB;EAChB,yCAAyC;EACzC,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,SAAO;EACP,YAAY;AACd;AACA,qDAAqD;AACrD;EACE,iBAAiB;AACnB;AACA;EACE,uCAAuC;AACzC;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,iBAAiB;AACnB;AACA,wBAAwB,cAAc,EAAE;AACxC,wBAAwB,cAAc,EAAE;;AAExC;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,mCAAmC;EACnC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,mBAAmB;EACnB,kCAAkC;EAClC,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,0BAA0B;EAC1B,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,SAAO;AACT;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,0BAA0B;EAC1B,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,qCAAqC;EACrC,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,0BAA0B;EAC1B,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,oBAAoB;EACpB,oBAAoB;AACtB;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA,mBAAmB;AACnB;EACE,oBAAoB,EAAE,mBAAmB,EAAE,WAAW;EACtD,kBAAkB,EAAE,kCAAkC;EACtD,yCAAyC;EACzC,8CAA8C;EAC9C,mBAAmB,EAAE,uBAAuB;AAC9C;;AAEA;;6DAE6D;;AAE7D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,6DAA6D;EAC7D,sCAAsC;AACxC;AACA;EACE,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,aAAa,EAAE,cAAc,EAAE,kBAAkB;EACjD,gCAAgC;EAChC,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,iBAAiB,EAAE,cAAc;EACjC,sBAAsB;AACxB;AACA,8BAA8B,gCAAgC,EAAE,cAAc,EAAE;;AAEhF;EACE,iBAAiB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,yBAAyB;EACtF,cAAc,EAAE,kBAAkB;AACpC;AACA;EACE,iBAAiB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,yBAAyB;EACtF,cAAc,EAAE,kBAAkB;AACpC;;AAEA,8CAA8C,8BAA8B,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,WAAW,EAAE,mBAAmB,EAAE;AACrJ,gDAAgD,8BAA8B,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE;;AAE1J;EACE,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE,uBAAuB;EACxE,kBAAkB,EAAE,mBAAmB;AACzC;AACA;iDACiD,6BAA6B,EAAE;AAChF;mDACmD,mCAAmC,EAAE;;AAExF;EACE,kBAAkB,EAAE,6BAA6B,EAAE,yBAAyB;AAC9E;AACA,4BAA4B,WAAW,EAAE;;AAEzC;EACE,kBAAkB,EAAE,mCAAmC;EACvD,mBAAmB,EAAE,gBAAgB,EAAE,gBAAgB;AACzD;;AAEA,sBAAsB,aAAa,EAAE,YAAY,EAAE,eAAe,EAAE,uBAAuB,EAAE;AAC7F;EACE,oBAAoB,EAAE,mBAAmB,EAAE,WAAW;EACtD,uBAAuB,EAAE,kBAAkB;EAC3C,kBAAkB,EAAE,gBAAgB,EAAE,eAAe;EACrD,yBAAyB,EAAE,YAAY;AACzC;AACA,qBAAqB,mBAAmB,EAAE,WAAW,EAAE;AACvD,0CAA0C,aAAa,EAAE;AACzD,8BAA8B,YAAY,EAAE,YAAY,EAAE;AAC1D,sBAAsB,kCAAkC,EAAE,4BAA4B,EAAE,uCAAuC,EAAE;AACjI,2CAA2C,kCAAkC,EAAE;;AAE/E,6BAA6B;AAC7B;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,uBAAuB,EAAE,sBAAsB;EAC/C,gCAAgC;EAChC,qCAAqC;AACvC;AACA,mBAAmB,kBAAkB,EAAE,cAAc,EAAE,cAAc,EAAE;AACvE,oBAAoB,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAC/F,kBAAkB,kBAAkB,EAAE,mCAAmC,EAAE,SAAS,EAAE,iBAAiB,EAAE;;AAEzG;EACE,sBAAsB,8BAA8B,EAAE,WAAW,EAAE;EACnE,0CAA0C,uBAAuB,EAAE,WAAW,EAAE;EAChF,mBAAmB,sBAAsB,EAAE,kBAAkB,EAAE;AACjE;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,qBAAqB;AACvB;AACA,2BAA2B,iCAAiC,EAAE,kCAAkC,EAAE;AAClG,+BAA+B,qBAAqB,EAAE,gCAAgC,EAAE;;AAExF,0BAA0B,kBAAkB,EAAE,gBAAgB,EAAE,WAAW,EAAE,kBAAkB,EAAE;AACjG;EACE,aAAa,EAAE,mBAAmB,EAAE,YAAY;EAChD,iBAAiB,EAAE,6BAA6B,EAAE,kBAAkB;AACtE;;AAEA;EACE,aAAa,EAAE,sBAAsB,EAAE,WAAW;EAClD,mBAAmB,EAAE,oBAAoB;EACzC,4CAA4C;AAC9C;AACA;EACE,aAAa,EAAE,uBAAuB,EAAE,YAAY;EACpD,uBAAuB;EACvB,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB,EAAE,6BAA6B;EACjD,eAAe,EAAE,qBAAqB;AACxC;AACA,2BAA2B,iCAAiC,EAAE;AAC9D,+BAA+B,qBAAqB,EAAE,gCAAgC,EAAE,gBAAgB,EAAE,WAAW,EAAE;AACvH,2BAA2B,qBAAqB,EAAE,cAAc,EAAE,eAAe,EAAE,cAAc,EAAE,kBAAkB,EAAE;AACvH,0BAA0B,aAAa,EAAE,sBAAsB,EAAE,WAAW,EAAE,SAAO,EAAE,YAAY,EAAE;;AAErG;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,kCAAkC;AACpC;;AAEA,uCAAuC;AACvC,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,WAAW,EAAE,mBAAmB,EAAE;AAC5F;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,qDAAqD;AACrD;EACE,oBAAoB,EAAE,mBAAmB,EAAE,WAAW,EAAE,kBAAkB;EAC1E,WAAW,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,0BAA0B,EAAE,0BAA0B;AAC3G;AACA,yBAAyB,cAAc,EAAE;AACzC,sBAAsB,qBAAqB,EAAE","sourcesContent":[".jrn__sub {\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  color: var(--portal-muted);\n  margin: -0.75rem 0 0;\n}\n.jrn__timeline {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  padding: 0.25rem 0 0.5rem;\n}\n\n/* Each step row */\n.jrn__tl-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 1.25rem;\n}\n\n/* Left track — dot + vertical connector line */\n.jrn__tl-track {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex-shrink: 0;\n  padding-top: 0.1rem;\n}\n\n/* The dot itself */\n.jrn__tl-dot {\n  width: 2.4rem;\n  height: 2.4rem;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  border: 2px solid transparent;\n  transition: all 0.2s;\n}\n.jrn__tl-dot--done {\n  background: #1e2a1e;\n  border-color: #1e2a1e;\n}\n.jrn__tl-dot--active {\n  background: transparent;\n  border-color: #b85c38;\n  box-shadow: 0 0 0 4px rgba(184, 92, 56, 0.15);\n}\n.jrn__tl-dot--pending {\n  background: transparent;\n  border-color: var(--portal-border, #e8e3da);\n}\n\n/* Check icon inside done dot */\n.jrn__tl-check {\n  font-size: 1.05rem;\n  color: #fff;\n  stroke-width: 2.5;\n}\n\n/* Step number inside pending/active dots */\n.jrn__tl-num {\n  font-size: 0.75rem;\n  font-weight: 800;\n  color: var(--portal-muted, #6b6258);\n}\n.jrn__tl-dot--active .jrn__tl-num {\n  color: #b85c38;\n}\n\n/* Connector line between dots */\n.jrn__tl-line {\n  width: 2px;\n  flex: 1;\n  min-height: 2rem;\n  background: var(--portal-border, #e8e3da);\n  margin: 0.35rem 0;\n}\n.jrn__tl-line--done {\n  background: #1e2a1e;\n}\n\n/* Right side — text label */\n.jrn__tl-label {\n  padding: 0.2rem 0 1.75rem;\n  flex: 1;\n  min-width: 0;\n}\n/* Last item — no bottom padding (no line below it) */\n.jrn__tl-item:last-child .jrn__tl-label {\n  padding-bottom: 0;\n}\n.jrn__tl-label--active {\n  /* subtle left accent for active step */\n}\n\n.jrn__tl-name {\n  font-family: var(--font-body);\n  font-size: 0.92rem;\n  font-weight: 700;\n  color: var(--portal-text, #1b1b1b);\n  margin: 0 0 0.25rem;\n  letter-spacing: 0;\n}\n.jrn__tl-name--active { color: #b85c38; }\n.jrn__tl-name--done   { color: #1e2a1e; }\n\n.jrn__tl-sub {\n  font-family: var(--font-body);\n  font-size: 0.82rem;\n  color: var(--portal-muted, #6b6258);\n  margin: 0;\n  line-height: 1.5;\n}\n\n.jrn__tl-date {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  font-size: 0.74rem;\n  color: var(--portal-muted, #6b6258);\n  margin: 0.35rem 0 0;\n  background: rgba(30, 42, 30, 0.06);\n  padding: 0.2rem 0.6rem;\n  border-radius: 99px;\n}\n.jrn__lower {\n  display: grid;\n  grid-template-columns: 1fr 1.6fr;\n  gap: var(--sp-4);\n  align-items: start;\n}\n.jrn__current {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: var(--sp-3);\n}\n.jrn__current-icon {\n  margin-block: var(--sp-3);\n}\n.jrn__current-title {\n  font-family: var(--font-body);\n  font-size: 1.02rem;\n  font-weight: 700;\n  color: var(--portal-rust);\n  margin: 0;\n}\n.jrn__current-desc {\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  color: var(--portal-muted);\n  margin: 0;\n  line-height: 1.55;\n}\n.jrn__current-note {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: var(--portal-surface);\n  border-radius: 6px;\n  padding: 0.65rem 0.85rem;\n  font-size: 0.734rem;\n  color: var(--portal-muted);\n}\n.jrn__current-note svg {\n  color: var(--portal-rust);\n  flex-shrink: 0;\n}\n.jrn__next-list {\n  display: flex;\n  flex-direction: column;\n  gap: var(--sp-4);\n}\n.jrn__next-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.85rem;\n}\n.jrn__next-body {\n  flex: 1;\n}\n.jrn__next-title {\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  font-weight: 700;\n  color: var(--portal-text);\n  margin: 0 0 0.2rem;\n}\n.jrn__next-desc {\n  font-family: var(--font-body);\n  font-size: 0.796rem;\n  color: var(--portal-muted);\n  margin: 0;\n  line-height: 1.45;\n}\n.jrn__next-time {\n  font-family: var(--font-body);\n  font-size: 0.663rem;\n  font-weight: 700;\n  color: var(--portal-rust);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.jrn__bottom {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--sp-5);\n  align-items: center;\n  overflow: hidden;\n  position: relative;\n}\n.jrn__quote {\n  font-family: var(--font-serif);\n  font-style: italic;\n  font-size: clamp(1rem, 1.5vw, 1.2rem);\n  color: var(--portal-muted);\n  margin: 0;\n  line-height: 1.5;\n}\n.jrn__quote cite {\n  display: block;\n  font-size: 0.694rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--portal-rust);\n  font-style: normal;\n  margin-top: 0.5rem;\n}\n.jrn__support {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--sp-3);\n}\n.jrn__support svg {\n  font-size: 1.224rem;\n  color: var(--portal-rust);\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n.jrn__support-title {\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  font-weight: 700;\n  color: var(--portal-text);\n  margin: 0 0 0.2rem;\n}\n.jrn__support-sub {\n  font-family: var(--font-body);\n  font-size: 0.796rem;\n  color: var(--portal-muted);\n  margin: 0;\n}\n.jrn__bottom-mtn {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: 180px;\n  height: 100px;\n  object-fit: cover;\n  opacity: 0.18;\n  pointer-events: none;\n  filter: grayscale(1);\n}\n@media (max-width: 767.98px) {\n  .jrn__lower {\n    grid-template-columns: 1fr;\n  }\n  .jrn__bottom {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ── Ref chip ── */\n.jrn__ref-chip {\n  display: inline-flex; align-items: center; gap: 0.4rem;\n  font-size: 0.78rem; color: var(--portal-muted,#6b6258);\n  background: var(--portal-surface,#faf7f2);\n  border: 1px solid var(--portal-border,#e8e3da);\n  border-radius: 99px; padding: 0.3rem 0.85rem;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   Retreat offer / queue cards\n═══════════════════════════════════════════════════════════ */\n\n.jrn__offer-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 2.25rem 2rem;\n  margin-bottom: 1.25rem;\n}\n.jrn__offer-card--pending {\n  background: linear-gradient(135deg, #1e2a1e 0%, #2d3e2d 100%);\n  border: 1px solid rgba(184,92,56,0.35);\n}\n.jrn__offer-card--confirmed {\n  background: rgba(22,163,74,0.05);\n  border: 1px solid rgba(22,163,74,0.25);\n}\n\n.jrn__offer-icon {\n  width: 3.5rem; height: 3.5rem; border-radius: 50%;\n  background: rgba(184,92,56,0.15);\n  display: flex; align-items: center; justify-content: center;\n  font-size: 1.5rem; color: #b85c38;\n  margin-bottom: 0.85rem;\n}\n.jrn__offer-icon--confirmed { background: rgba(22,163,74,0.15); color: #16a34a; }\n\n.jrn__offer-card--pending .jrn__offer-eyebrow {\n  font-size: 0.7rem; font-weight: 700; letter-spacing: 0.16em; text-transform: uppercase;\n  color: #b85c38; margin: 0 0 0.5rem;\n}\n.jrn__offer-card--confirmed .jrn__offer-eyebrow {\n  font-size: 0.7rem; font-weight: 700; letter-spacing: 0.16em; text-transform: uppercase;\n  color: #16a34a; margin: 0 0 0.5rem;\n}\n\n.jrn__offer-card--pending .jrn__offer-title { font-family: var(--font-serif); font-size: 1.5rem; font-weight: 700; color: #fff; margin: 0 0 0.65rem; }\n.jrn__offer-card--confirmed .jrn__offer-title { font-family: var(--font-serif); font-size: 1.5rem; font-weight: 700; color: #1b1b1b; margin: 0 0 0.65rem; }\n\n.jrn__offer-dates, .jrn__offer-location {\n  display: flex; align-items: center; gap: 0.4rem; justify-content: center;\n  font-size: 0.88rem; margin: 0 0 0.35rem;\n}\n.jrn__offer-card--pending .jrn__offer-dates,\n.jrn__offer-card--pending .jrn__offer-location { color: rgba(255,255,255,0.75); }\n.jrn__offer-card--confirmed .jrn__offer-dates,\n.jrn__offer-card--confirmed .jrn__offer-location { color: var(--portal-muted, #6b6258); }\n\n.jrn__offer-expiry {\n  font-size: 0.85rem; color: rgba(255,255,255,0.65); margin: 0.85rem 0 1.25rem;\n}\n.jrn__offer-expiry strong { color: #fff; }\n\n.jrn__offer-confirmed-note {\n  font-size: 0.85rem; color: var(--portal-muted, #6b6258);\n  margin: 0.85rem 0 0; max-width: 400px; line-height: 1.6;\n}\n\n.jrn__offer-actions { display: flex; gap: 0.65rem; flex-wrap: wrap; justify-content: center; }\n.jrn__offer-accept, .jrn__offer-decline {\n  display: inline-flex; align-items: center; gap: 0.4rem;\n  padding: 0.7rem 1.35rem; border-radius: 8px;\n  font-size: 0.86rem; font-weight: 700; cursor: pointer;\n  transition: opacity 0.15s; border: none;\n}\n.jrn__offer-accept { background: #b85c38; color: #fff; }\n.jrn__offer-accept:hover:not(:disabled) { opacity: 0.88; }\n.jrn__offer-accept:disabled { opacity: 0.5; cursor: wait; }\n.jrn__offer-decline { background: rgba(255,255,255,0.08); color: rgba(255,255,255,0.7); border: 1px solid rgba(255,255,255,0.2); }\n.jrn__offer-decline:hover:not(:disabled) { background: rgba(255,255,255,0.14); }\n\n/* ── Queue waiting card ── */\n.jrn__queue-card {\n  display: flex; align-items: center; gap: 1rem;\n  padding: 1.25rem 1.5rem; margin-bottom: 1.25rem;\n  background: rgba(217,119,6,0.05);\n  border: 1px solid rgba(217,119,6,0.2);\n}\n.jrn__queue-icon { font-size: 1.75rem; color: #d97706; flex-shrink: 0; }\n.jrn__queue-title { font-size: 0.92rem; font-weight: 700; color: #1b1b1b; margin: 0 0 0.25rem; }\n.jrn__queue-sub { font-size: 0.82rem; color: var(--portal-muted, #6b6258); margin: 0; line-height: 1.55; }\n\n@media (max-width: 640px) {\n  .jrn__offer-actions { flex-direction: column-reverse; width: 100%; }\n  .jrn__offer-accept, .jrn__offer-decline { justify-content: center; width: 100%; }\n  .jrn__queue-card { flex-direction: column; text-align: center; }\n}\n\n/* ── Open selection block/room picker ── */\n.jrn__block-picker {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  width: 100%;\n  margin: 1.25rem 0;\n  text-align: left;\n}\n.jrn__block-option {\n  background: rgba(255,255,255,0.06);\n  border: 1.5px solid rgba(255,255,255,0.15);\n  border-radius: 10px;\n  padding: 0.9rem 1.1rem;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n.jrn__block-option:hover { border-color: rgba(184,92,56,0.5); background: rgba(255,255,255,0.09); }\n.jrn__block-option--selected { border-color: #b85c38; background: rgba(184,92,56,0.12); }\n\n.jrn__block-option-name { font-size: 0.95rem; font-weight: 700; color: #fff; margin: 0 0 0.3rem; }\n.jrn__block-option-dates {\n  display: flex; align-items: center; gap: 0.35rem;\n  font-size: 0.8rem; color: rgba(255,255,255,0.65); margin: 0 0 0.2rem;\n}\n\n.jrn__roomtype-picker {\n  display: flex; flex-direction: column; gap: 0.5rem;\n  margin-top: 0.75rem; padding-top: 0.75rem;\n  border-top: 1px solid rgba(255,255,255,0.12);\n}\n.jrn__roomtype-opt {\n  display: flex; align-items: flex-start; gap: 0.55rem;\n  padding: 0.6rem 0.75rem;\n  border: 1px solid rgba(255,255,255,0.15);\n  border-radius: 7px;\n  font-size: 0.82rem; color: rgba(255,255,255,0.85);\n  cursor: pointer; transition: all 0.13s;\n}\n.jrn__roomtype-opt:hover { border-color: rgba(184,92,56,0.5); }\n.jrn__roomtype-opt--selected { border-color: #b85c38; background: rgba(184,92,56,0.15); font-weight: 600; color: #fff; }\n.jrn__roomtype-opt input { accent-color: #b85c38; width: 0.95rem; height: 0.95rem; flex-shrink: 0; margin-top: 0.2rem; }\n.jrn__roomtype-opt-body { display: flex; flex-direction: column; gap: 0.5rem; flex: 1; min-width: 0; }\n\n.jrn__roomtype-photos {\n  display: flex;\n  gap: 0.4rem;\n  flex-wrap: wrap;\n}\n.jrn__roomtype-photos img {\n  width: 3.75rem;\n  height: 3.75rem;\n  object-fit: cover;\n  border-radius: 6px;\n  flex-shrink: 0;\n  background: rgba(255,255,255,0.08);\n}\n\n/* ── Targeted offer's room photos ── */\n.jrn__offer-room { display: flex; flex-direction: column; gap: 0.5rem; align-items: center; }\n.jrn__offer-room-photos {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n.jrn__offer-room-photos img {\n  width: 4.5rem;\n  height: 4.5rem;\n  object-fit: cover;\n  border-radius: 8px;\n  background: rgba(255,255,255,0.08);\n}\n\n/* Link from the confirmed card to the booking page */\n.jrn__offer-link {\n  display: inline-flex; align-items: center; gap: 0.4rem; margin-top: 0.9rem;\n  color: #fff; font-weight: 700; font-size: 0.85rem; text-decoration: underline; text-underline-offset: 3px;\n}\n.jrn__offer-link:hover { color: #f0a47f; }\na.jrn__offer-accept { text-decoration: none; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
